import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import { getAxiosCancelToken } from "../../utils/getAxiosCancelToken";

let cancelToken;
const getManageTranscription = (searchText, pageNumber, pageSize) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_TRANSCRIPTION_DETAILS(
      searchText,
      pageNumber,
      pageSize
    ),
    "",
    cancelToken
  );
};

export default getManageTranscription;
